import { RequestOptions, ApiResponse, Day, IEvent, User, HOST } from './types';
import { jwtDecode } from 'jwt-decode';

export const xhr = async (options: RequestOptions): Promise<any> => {
    const { url, method = 'GET', headers = {}, body } = options;

    const response = await fetch(url, {
        method,
        headers: {
            'Content-Type': 'application/json',
            ...headers,
        },
        credentials: 'include',
        body: body ? JSON.stringify(body) : undefined,
    });

    if (response.status == 401) {
        if (!options.isOnPageLoad) {
            window.location.reload();
        }
        return {
            error: `${response.status}`
        } as ApiResponse
    }

    let res = await response.json() as ApiResponse;

    if (res.error) {
        alert(res.error);
    }

    return res;
}

export const capitalizeKeys = (obj: any): any => {
    if (Array.isArray(obj)) {
        return obj.map(capitalizeKeys);
    } else if (obj !== null && typeof obj === 'object') {
        return Object.keys(obj).reduce((acc, key) => {
            const newKey = key.charAt(0).toUpperCase() + key.slice(1);
            acc[newKey] = capitalizeKeys(obj[key]);
            return acc;
        }, {} as { [key: string]: any });
    }
    return obj;
};

export const serializeRow = <T>(tr: HTMLElement, cls: new () => T, additionalProperties: any): T => {
    const instance = new cls();
    const keys = Object.keys(instance as {}) as (keyof T)[];
    const additionalPropertyKeys = Object.keys(additionalProperties as {}) as (keyof T)[];
    const result = {} as T;
    let error = false;
    
    for (const key of keys) {
        const input = tr.querySelector<HTMLInputElement>(`[name="${new String(key)}"]`);
        if (input) {
            result[key] = input.value as any;
        }
    }

    for (let prop of additionalPropertyKeys) {
        result[prop] = additionalProperties[prop];
    }

    return result;
};

export const findLastDayOfMonth = (monthIndex: number, month: Day[][], user: User): Day => {
    const today = new Date();
    for (let i = month.length - 1; i >= 0; i--) {
        for (let j = month[i].length - 1; j >= 0; j--) {
            let day: Day = month[i][j] as Day;
            if (day.month == monthIndex) {
                return day;
            }
        }
    }
    return {} as Day;
}

export const findLastEventOfMonth = (monthIndex: number, month: Day[][], user: User): IEvent => {
    const today = new Date();

    for (let i = month.length - 1; i >= 0; i--) {
        for (let j = month[i].length - 1; j >= 0; j--) {
            let day: Day = month[i][j] as Day;
            if (day.month == monthIndex) {
                if (today.getFullYear() == day.year && day.month - 1 == today.getMonth() && day.date == today.getDate()) {
                    return { total: user.checkingBalance } as IEvent;
                } else if (day.events.length) {
                    return day.events[day.events.length - 1] as IEvent;
                }
            }
        }
    }
    
    return {} as IEvent;
}

export const CHANGE_THEME = (user: User, theme: string): Promise<string> => {
    return new Promise((resolve: any) => {
        xhr({
            method: 'PUT',
            url: HOST + '/set-theme/' + theme
        }).then((res: ApiResponse)=> {
            resolve(res.data)
        });
    });
        
}

export const sizeDayBlocks = (): void => {
    
}

export const funBackground = function (stops: number = 111): Record<string, any>[] {
    const baseAngles = [45, 135, 225, 315];
    const colorPalettes = [
        ['white', 'lightsteelblue', 'lavender'],
        ['mistyrose', 'peachpuff', 'lightyellow'],
        ['honeydew', 'palegreen', 'lightcyan'],
        ['linen', 'thistle', 'lemonchiffon']
    ];

    const generateGradient = (angle: number, colors: string[]): string => {
        const colorRef = { current: colors[0] };

        const nextColor = () => {
            const idx = colors.indexOf(colorRef.current);
            colorRef.current = colors[(idx + 1) % colors.length];
            return colorRef.current;
        };

        return `repeating-linear-gradient(
            ${Math.random() < 0.5 ? '-' : ''}${angle}deg,
            ${Array.from({ length: stops }).flatMap((_, i) => {
                if (i % 3 === 0 && Math.random() < 0.85) {
                    return [`${nextColor()} ${(100 * (i / stops)).toFixed(0)}%,`];
                }
                return [];
            }).join(' ')}
        )`.replace(/,\s*\)/, ')');
    };

    return baseAngles.map((angle, idx) => {
        const rawBackground = generateGradient(angle, colorPalettes[idx]);

        return {
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
            fontFamily: 'system-ui',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#000',
            fontWeight: 300,
            textShadow: '-1px -1px rgba(255, 255, 255, 0.4)',
            background: rawBackground
        };
    });
};
